import React from 'react'
import Card from '../../atoms/Card/Card'
import CheckBox from '../../atoms/Checkbox/CheckBox'
import RadioButton from '../../atoms/RadioButton/RadioButton'
import { CardContent, CardContentSection, Divider, StyledHeading, Description, Cost } from './ProductCard.styles'

export enum Variant {
  Checkbox,
  Radio,
}

export type ProductCardProps = {
  title: string
  description: string[]
  cost?: string
  buttonLabel: string
  selected: boolean
  onClick: () => void
  variant?: Variant
  id: string
}

const ProductCard: React.FunctionComponent<ProductCardProps> = ({
  description,
  title,
  cost,
  selected,
  buttonLabel,
  onClick,
  variant = Variant.Radio,
  id,
}) => {
  return (
    <Card selected={selected} data-testid="productCard">
      <CardContent>
        <CardContentSection>
          <StyledHeading>{title}</StyledHeading>
          {description.map(item => (
            <Description key={item}>{item}</Description>
          ))}
        </CardContentSection>
        <CardContentSection>
          <Cost>{cost}</Cost>
          <Divider />
          {variant === Variant.Checkbox ? (
            <CheckBox label={buttonLabel} checked={selected} id={`${id}-checkbox`} onClick={() => onClick()} />
          ) : (
            <RadioButton
              label={buttonLabel}
              checked={selected}
              name={buttonLabel}
              id={`${id}-radio`}
              onChange={() => onClick()}
            />
          )}
        </CardContentSection>
      </CardContent>
    </Card>
  )
}

export default ProductCard
